import {
  BroadcastReminderEmailResponse,
  FileSignedUrl,
  PageSubmissionsCycle,
  PageSubmissionsSummary,
  PageSubmissionsSummarySecretariat,
  SubmissionsStatistics,
  SubmissionsWithOrgData,
  SubmissionsWithSubmissionsData,
} from "@rr/shared-data-access-api";

export interface SubmissionState {
  forms: PageSubmissionsCycle | null;
  isLoading: {
    listForms: boolean;
    listSubmissionsBySecretariat: boolean;
    listSubmissionsByRecipient: boolean;
    add: boolean;
    remove: boolean;
    loadSubmissionDetail: boolean;
    createOrUpdateSubmissionData: boolean;
    getStatistics: boolean;
    getSummary: boolean;
    getSignedFiles: boolean;
    broadcastReminder: boolean;
  };
  error: { error: { errors: { detail: string }[] } } | null;
  refreshSubmissions: boolean;
  secretariatSubmissions: SubmissionsWithOrgData[] | null;
  tenantSubmissions: SubmissionsWithOrgData[] | null;
  statistics: SubmissionsStatistics[] | null;
  upstreamSummary: PageSubmissionsSummary | null;
  secretariatSummary: PageSubmissionsSummarySecretariat | null;
  selectedSubmission: SubmissionsWithSubmissionsData | null;
  signedFiles: FileSignedUrl[] | null;
  reminderEmail: BroadcastReminderEmailResponse | null;
}

export const initialState: SubmissionState = {
  forms: null,
  isLoading: {
    listForms: false,
    listSubmissionsBySecretariat: false,
    listSubmissionsByRecipient: false,
    add: false,
    remove: false,
    loadSubmissionDetail: false,
    createOrUpdateSubmissionData: false,
    getStatistics: false,
    getSummary: false,
    getSignedFiles: false,
    broadcastReminder: false,
  },
  error: null,
  refreshSubmissions: false,
  secretariatSubmissions: null,
  tenantSubmissions: null,
  selectedSubmission: null,
  statistics: null,
  upstreamSummary: null,
  secretariatSummary: null,
  signedFiles: null,
  reminderEmail: null,
};
